import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as shop from './types';

const mutations = {
  [shop.SET_SHOPS](state, shops) {
    state.shops = {
      content: shops.content,
      totalElements: shops.pagination.totalElements,
    };
    console.log('[SHOPS]');
    console.log(shops);
  },
  [shop.SET_RECOMMEND_SHOPS](state, shops) {
    state.shopsRecommend = {
      content: shops.content,
      totalElements: shops.pagination.totalElements,
    };
    console.log('[RECOMMEND_SHOPS]');
    console.log(shops);
  },
  [shop.SET_SHOP](state, shop) {
    let startIdx = shop.reviews.length;

    const newData = shop.reviews.reduce((p, c) => {
      c.idx = startIdx--;
      c.createdAt = c.createdAt
        ? format(parseISO(c.createdAt), 'yyyy-MM-dd')
        : c.createdAt;
      p.push(c);
      return p;
    }, []);
    state.shop.reviews = newData;

    // 2개 이상이면 디폴트 사진은 노출을 안시킨다. (hsh)
    var pho_splice = false;
    const phoLeng = shop.storePhotos.length;
    if (phoLeng > 1) {
      for (var i = 0; i < phoLeng; i++) {
        // console.log(shop.storePhotos[i].defaultPhoto);
        if (shop.storePhotos[i].defaultPhoto == 1) {
          var i_key = i;
          pho_splice = true;
        }
      }
      if (pho_splice) {
        shop.storePhotos.splice(i_key, 1);
      }
    }

    // 응답시간, 채팅방 개수 구하기 (hsh)
    // if (shop.chatRooms) {
    //   shop.chatRoomsCnt = shop.chatRooms.length;

    //   var responseMinuteArr = [];

    //   if (shop.chatRoomsCnt > 0) {
    //     for (var cnt = 0; cnt < shop.chatRoomsCnt; cnt++) {
    //       responseMinuteArr.push(shop.chatRooms[cnt].responseMinute);
    //     }
    //   }

    //   shop.responseMinuteAvg = 0;

    //   if (responseMinuteArr.length > 0) {
    //     shop.responseMinuteArr = responseMinuteArr;
    //     const average = arr => arr.reduce((p, c) => p + c, 0) / arr.length;

    //     shop.responseMinuteAvg = Math.floor(average(responseMinuteArr));
    //   }

    //   shop.responseMinuteText = '';

    //   if (shop.responseMinuteAvg > 0) {
    //     if (shop.responseMinuteAvg < 10) {
    //       shop.responseMinuteText = '10분 이내';
    //     } else if (shop.responseMinuteAvg < 30) {
    //       shop.responseMinuteText = '30분 이내';
    //     } else if (shop.responseMinuteAvg < 60) {
    //       shop.responseMinuteText = '1시간 이내';
    //     } else if (shop.responseMinuteAvg < 120) {
    //       shop.responseMinuteText = '2시간 이내';
    //     } else if (shop.responseMinuteAvg < 360) {
    //       shop.responseMinuteText = '6시간 이내';
    //     } else {
    //       shop.responseMinuteText = '6시간 이상';
    //     }
    //   }
    // }

    console.log('[shop]');
    console.log(shop);

    state.shop = shop;
  },
  [shop.SET_SHOP_PRIOR_CONSENT](state, shops) {
    state.shopPriorConsent = shops;
    console.log('[SET_SHOP_PRIOR_CONSENT]');
  },
  [shop.SET_SHOP_VOUCHERS](state, shops) {
    state.shopVouchers = shops;
    console.log('[SET_SHOP_VOUCHERS]');
  },
  [shop.SET_SHOP_VOUCHERS_USE](state, shops) {
    state.vouchersUseResult = shops;
    console.log('[SET_SHOP_VOUCHERS_USE]');
    // console.log(shops);
  },
};

export default mutations;
